// ========== HowItWorksPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';
import AdUnit from '../components/AdUnit';
import AdRotator from '../components/AdRotator';

const HowItWorksPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>
      {/* Place the AdUnit adsense component here */}
      <section className='headerAd'>
        <AdRotator floating={true} placement="sidebar" />
       {/* <AdUnit adSlot="8074484061" /> */}
      </section>
      
    
    
  
      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1>How It Works</h1>
          <p>From ancient oracles to modern AI: Understanding your statistical future</p>
        </div>

        <div className="content-section">
          <h2> Step 1: From Ancient Wisdom to Modern Science</h2>
          <p>Throughout history, humans have sought to predict the future�from ancient oracles and horoscopes to medieval almanacs and astronomical records. Today, we use AI and Big Data to provide scientifically-grounded predictions.</p>
          <p>Just as Google Maps predicts your arrival time using traffic data, Mellodai predicts life events using historical human patterns.</p>
        </div>

        <div className="content-section">
          <h2> Step 2: Input Your Life Events</h2>
          <p>You begin by entering a sequence of major life events from your past:</p>
          <ul>
            <li> Graduated High School</li>
            <li> Started First Job</li>
            <li> Got Engaged</li>
            <li> Bought First Home</li>
          </ul>
          <p>The more events you input, the more accurate your prediction becomes.</p>
        </div>

        <div className="content-section">
          <h2> Step 3: AI Neural Network Analysis</h2>
          <p>Our Neural Network compares your sequence against 25 years of population data from 10,000+ surveyed individuals.</p>
          <p>The AI identifies subtle patterns invisible to human analysis and calculates the statistical probability of your next major life event.</p>
        </div>

        <div className="content-section">
          <h2> Step 4: Receive Your Statistical Forecast</h2>
          <p>Within seconds, you receive a calculated probability�a data-backed forecast of your most likely next major life event with a confidence score.</p>
          <p style={{marginTop: '2rem', fontStyle: 'italic'}}>Remember: This is not a prophecy�it's a statistical probability that empowers you to make informed decisions.</p>
        </div>

        <div className="cta-section">
          <h2>Ready to See Your Statistical Future?</h2>
          <button className="btn-primary" onClick={() => navigate('/login')}>Try Your First Prediction</button>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HowItWorksPage;
